import inventories from "../services/estore.inventories";

import notification from "../services/notification";
import router from "../router";

export default {
    namespaced: true,

    state: {
        loading: false,
        errors: null,
        products: [],
        categories: [],
        advance_search: [],
        param: {
            page: 1,
            payload: {
                filters: {
                    paired_key: "all",
                    keyword: "",
                    column: "all"
                }
            }
        },
        payment_type: null,
        pagination: {
            currentPage: 1,
            prevPage: 0,
            nextPage: 0,
            maxPage: 0,
            totalPerPage: 1,
            currentFirstItem: 1,
            currentLastItem: 1,
            initialPageCount: 0,
            perPage: 10
        },
        modal: {
            new_product: {
                status: false
            },
            edit_product: {
                status: false
            },
            croppa: {
                status: false,
                base64: null,
                origin: null
            },
            delete_product: {
                status: false,
                name: "",
                uuid: null,
                is_tagged: 0
            },
            check_tagged_product: {
                status: false,
                name: "",
                uuid: null
            },

            delete_multiple_products: {
                status: false,
                product_ids: [],
                merchant_uuid: "",
                has_tagged_products: 0
            }
        },
        product_active_img: null,
        sale: {
            dates: {
                on_sale_from: null,
                on_sale_to: null
            },
            all: false,
            all_discount_value: 1,
            all_discount_type: "%"
        },
        product_data: {},
        filteredCategories: [],
        isSaving: false
    },

    mutations: {
        loading(state, status) {
            state.loading = status;
        },

        errors(state, errors) {
            if (errors !== null) {
                state.errors = errors.errors;
            } else {
                state.errors = errors;
            }
        },

        setAdvanceSearchOptions(state, values) {
            state.advance_search = values;
        },

        setParam(state, param) {
            state.param = param;
        },

        setProducts(state, products) {
            state.products = products;
        },

        setCategories(state, categories) {
            state.categories = categories;
        },

        setInitialPageCount(state, list) {
            state.pagination.initialPageCount = list.length;
        },

        setCurrentPage(state, page) {
            state.pagination.currentPage = page;
        },

        setParamPage(state, page){
            state.param.page = page;
        },

        setPagination(state, pagination) {
            state.pagination.totalPerPage = pagination.list.length;
            state.pagination.maxPage =
                state.pagination.totalPerPage > 0 ? pagination.max_page : 0;
            state.pagination.prevPage = pagination.prev_page;
            state.pagination.nextPage = pagination.next_page;
            state.pagination.currentPage = state.pagination.prevPage + 1;
            state.pagination.currentFirstItem =
                state.pagination.totalPerPage > 0
                    ? state.pagination.initialPageCount *
                    state.pagination.prevPage +
                    1
                    : 0;
            state.pagination.currentLastItem =
                state.pagination.currentFirstItem > 0
                    ? state.pagination.currentFirstItem +
                    state.pagination.totalPerPage -
                    1
                    : 0;
        },

        setModal(state, param) {
            state.modal[param.type].status = param.status;

            if (param.type === "croppa") {
                state.modal[param.type].base64 = param.base64;
                state.modal[param.type].origin = param.origin;

                if (param.status == false) {
                    state.modal[param.origin].status = true;
                }
            }

            if (param.type === "delete_product") {
                state.modal[param.type].uuid = param.uuid;
                state.modal[param.type].name = param.name;
                state.modal[param.type].is_tagged = param.is_tagged;
            }

            if (param.type === "check_tagged_product") {
                state.modal[param.type].uuid = param.uuid;
                state.modal[param.type].name = param.name;
            }

            if (param.type === "delete_multiple_products") {
                state.modal[param.type].merchant_uuid = param.merchant_uuid;
                state.modal[param.type].product_ids = param.product_ids;
                state.modal[param.type].has_tagged_products = param.has_tagged_products;
            }
        },

        setActiveImage(state, index) {
            state.product_active_img = index;
        },

        setProductData(state, data) {
            state.product_data = data;
        },

        setPaymentType(state, type) {
            state.payment_type = type;
        },

        setTaggedProducts(state, taggedProducts) {
            state.taggedProducts = taggedProducts;
        },

        setFilteredCategories(state, categories) {
            state.filteredCategories = categories;
        },

        setIsSaving(state, status) {
            state.isSaving = status;
        },

        setCategoryUpdateError(state, errors) {
            state.errors = errors;
        }
    },

    getters: {
        categories: state => state.categories,
        filteredCategories: state => state.filteredCategories,
        loading: state => state.loading,
        isSaving: state => state.isSaving,
        errors: state => state.errors,
        deleteMultipleProductsState: state => state.modal.delete_multiple_products,
    },

    actions: {
        async getCategories({ commit, state }, payload) {
            commit("loading", true);
            state.categories = [];
            try {
                let { data } = await inventories.getCategories(payload);
                commit("setCategories", data);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },

        async getFilteredCategories({ commit, state }, payload) {
            commit("loading", true);
            state.filteredCategories = [];
            try {
                const { data } = await inventories.getCategories(payload);
                commit("setFilteredCategories", data);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },

        async getAdvanceSearch({ commit }) {
            commit("loading", true);
            try {
                let response = await inventories.getAdvanceSearch();
                commit("setAdvanceSearchOptions", response.options);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },

        async getProducts({ commit, state }, param) {
            commit("loading", true);
            state.products = [];
            try {
                let response = await inventories.getProducts(param);

                if (param.page === 1) {
                    await commit("setInitialPageCount", response.list);
                }

                response.list.forEach(function (cell) {
                    if (cell.on_sale === 0) {
                        cell["_cellVariants"] = {
                            sale_price: "secondary",
                            sale_schedule: "secondary"
                        };
                    } else {
                        var onSaleToDate = new Date(cell.on_sale_to);
                        var now = new Date();
                        if (onSaleToDate < now) {
                            cell["_cellVariants"] = { sale_price: "secondary" };
                        }
                    }
                });
                commit("setProducts", response.list);
                commit("setPagination", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },

        async saveSimpleProduct({ commit, dispatch }, param) {
            const { query } = router.currentRoute;
            commit("loading", true);
            try {
                let response;
                if (query.mode === "onboarding") {
                    await dispatch("onboarding/getMerchantSetup", null, { root: true });

                    const { progress } = this.state.onboarding.merchantStatus;

                    const productSubStepStatus = progress
                        .find(opt => opt.step === "1").substeps
                        .find(subOpt => subOpt.sub === "1.2").status;
                    
                    if (productSubStepStatus !== "Completed") {
                        response = await inventories.saveSimpleProduct(param, "v2");
                    } else {
                        response = await inventories.saveSimpleProduct(param);
                    }
                } else {
                    response = await inventories.saveSimpleProduct(param);
                }
                commit("loading", false);
                commit("errors", null);
                notification.success(response.message);
                if (query.mode === "onboarding")
                    router.push({ name: "onboarding" });
                else 
                    router.push({ name: "Products" });
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
                notification.warning("Oops, cannot create new product.");
            }
        },

        async updateProductVisibility({}, data) {
            try {
                let response = await inventories.updateProductVisibility(data);
                notification.success(response.message);
            } catch (errors) {
                notification.warning("Oops, cannot update product visibility");
            }
        },

        async getProduct({ commit }, param) {
            commit("loading", true);
            try {
                let response = await inventories.getProduct(param);
                commit("loading", false);
                commit("setProductData", response[param.type]);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },

        async updateSimpleProduct({ commit }, param) {
            commit("loading", true);
            try {
                let response = await inventories.updateSimpleProduct(param);
                commit("loading", false);
                commit("errors", null);
                notification.success(response.message);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
                notification.warning("Oops, cannot update product.");
            }
        },

        async deleteProduct({ commit }, param) {
            commit("loading", true);
            try {
                let response = await inventories.deleteProduct(param.uuid);
                commit("loading", false);
                commit("errors", null);
                notification.success(response.message);
            } catch (errors) {
                commit("errors", errors.errors);
                commit("loading", false);
                // notification.warning(errors.errors.message);
                commit("setModal", {
                    type: "check_tagged_product",
                    uuid: param.uuid,
                    name: param.name,
                    status: true
                });
            }
        },

        async deleteMultipleProduct({ commit }, param) {
            commit("loading", true);
            try {
                let response = await inventories.deleteMultipleProducts(param);
                commit("loading", false);
                commit("errors", null);
                notification.success(response.message);
            } catch (errors) {
                commit("errors", errors.errors);
                commit("loading", false);
                notification.warning(errors.errors.message);
            }
        },

        async saveVariableProduct({ commit, dispatch }, param) {
            const { query } = router.currentRoute
            commit("loading", true);
            try {
                let response = await inventories.saveVariableProduct(param);
                commit("loading", false);
                commit("errors", null);
                notification.success(response.message);
                if (query.mode === "onboarding") {
                    router.push({ name: "onboarding" });
                } else {
                    router.push({ name: "Products" });
                }
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
                notification.warning("Oops, cannot create new product");
            }
        },

        async updateVariableProduct({ commit }, param) {
            commit("loading", true);
            try {
                let response = await inventories.updateVariableProduct(param);
                commit("loading", false);
                commit("errors", null);
                notification.success(response.message);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
                notification.warning("Oops, cannot update product.");
            }
        },

        async importSimpleProduct({ commit }, params) {
            commit("loading", true);
            commit("errors", null);

            try {
                await inventories.importSimpleProduct(params);
                notification.success("Upload successful.");
            } catch (errors) {
                commit("errors", errors);
                notification.warning("Oops, cannot upload simple product.");
            } finally {
                commit("loading", false);
            }
        },

        async importVariableProduct({ commit }, params) {
            commit("loading", true);
            try {
                await inventories.importVariableProduct(params);
                commit("errors", null);
                notification.success("Upload successful.");
            } catch (errors) {
                commit("errors", null);
                notification.warning("Oops, cannot upload variable product.");
            } finally {
                commit("loading", false);
            }
        },

        async productDelete({ commit }, params) {
            commit("loading", true);
            try {
                const { message } = await inventories.productDelete(params);
                notification.success(message);
            } catch (errors) {
                commit("errors", null);
                commit("setModal", {
                    type: "check_tagged_product",
                    uuid: null,
                    name: "",
                    status: true
                });
            } finally {
                commit("loading", false);
            }
        },

        async addCategory({ commit }, payload) {
            commit("setIsSaving", true);
            commit("errors", null);
            try {
                const { message } = await inventories.addCategory(payload);
                notification.success(message);
            } catch (errors) {
                commit("errors", errors);
                notification.warning(
                    "Oops, something went wrong. Please try again."
                );
            } finally {
                commit("setIsSaving", false);
            }
        },

        async updateCategory({ commit }, payload) {
            commit("setIsSaving", true);
            commit("errors", null);
            try {
                const { message } = await inventories.updateCategory(payload);
                notification.success(message);
            } catch (errors) {
                const computedError = {
                    id: payload.category_id,
                    error: errors.errors["category_name"]
                };
                commit("setCategoryUpdateError", computedError);
                notification.warning(
                    "Oops, something went wrong. Please try again."
                );
            } finally {
                commit("setIsSaving", false);
            }
        },

        async deleteCategory({ commit }, id) {
            commit("setIsSaving", true);
            commit("errors", null);
            try {
                const { message } = await inventories.deleteCategory(id);
                notification.success(message);
            } catch (errors) {
                commit("errors", errors);
                notification.warning(errors.errors.message);
            } finally {
                commit("setIsSaving", false);
            }
        }
    }
};
